export const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/+$/, "");

/**
 * Post a contact form submission directly to the main LiveSphere API (no local BFF).
 *
 * Configure REACT_APP_API_BASE_URL at build/runtime, e.g.
 *   REACT_APP_API_BASE_URL=https://www.yourdomain.com/api
 *
 * By default, if unset, requests go to /api (same host).
 */
export async function submitContactForm(payload) {
  const base = API_BASE_URL || "/api";
    const endpoint =  "/webpage/addcontactformsubmission";
  const url = `${base}${endpoint.startsWith("/") ? "" : "/"}${endpoint}`;

  const res = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  // Treat 200-299 as success
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    const err = new Error(`Contact submit failed: ${res.status} ${res.statusText}`);
    err.details = text;
    throw err;
  }

  // Some APIs return no JSON; be tolerant
  const ct = res.headers.get("content-type") || "";
  if (ct.includes("application/json")) return await res.json();
  return await res.text().catch(() => "");
}
